import { PANEL_NAME_KEY, TRIP_STATE } from '@allocab/allocab-commons-shared-types';
import { TripForDriverOutput } from '@allocab/allocab-driver-shared-types';

import { assertNever } from './common';
import { t, tPlural } from '../services/translation/translation';

export type TripStep = 'ACCEPTED' | 'APPROACHING' | 'ON_SITE' | 'ON_DUTY' | 'ON_PAYMENT' | 'DONE' | 'CANCELLED';

export const getStepForTrip = (trip: TripForDriverOutput): TripStep => {
  const { state, subState } = trip;

  if (state === 'INCOMING') {
    if (subState === 'STANDBY_BEFORE_APPROACH_INCOMING') {
      return 'ACCEPTED';
    }

    if (subState === 'IN_APPROACH_INCOMING') {
      return 'APPROACHING';
    }

    if (subState === 'IN_PLACE_INCOMING') {
      return 'ON_SITE';
    }
  }

  if (state === 'ONDUTY') {
    return 'ON_DUTY';
  }

  if (state === 'ONPAYMENT') {
    if (isTaxiTrip(trip)) {
      return 'ON_PAYMENT';
    }

    return 'ON_DUTY';
  }

  if (state === 'DONE') {
    return 'DONE';
  }

  if (state === 'CANCELLED') {
    return 'CANCELLED';
  }

  return 'ACCEPTED';
};

export const getTripStatus = (trip: TripForDriverOutput) => {
  const step = getStepForTrip(trip);

  switch (step) {
    case 'ACCEPTED':
      return t('trip.status.accepted');
    case 'APPROACHING':
      return t('trip.status.approaching');
    case 'ON_SITE':
      return tPlural('trip.status.on-site', { count: 1 + (trip.otherPassengers?.length ?? 0) });
    case 'ON_DUTY':
      return t('trip.status.on-duty');
    case 'ON_PAYMENT':
      return t('trip.status.on-payment');
    case 'DONE':
      return t('trip.status.done');
    case 'CANCELLED':
      return t('trip.status.cancelled');
    default:
      assertNever(step, '[getTripStatus] Step unknown');
      return t('common.unknown');
  }
};

export const getTripStateName = (state: TRIP_STATE) => {
  switch (state) {
    case 'INCOMING':
      return t('trip.state.incoming');
    case 'ONDUTY':
      return t('trip.state.onduty');
    case 'ONPAYMENT':
      return t('trip.state.onpayment');
    case 'DONE':
      return t('trip.state.done');
    case 'CANCELLED':
      return t('trip.state.cancelled');
    default:
      assertNever(state, '[getTripStatus] Step unknown');
      return t('common.unknown');
  }
};

const isTaxiPanel = (key: PANEL_NAME_KEY) => key === 'TAXI' || key === 'TAXI_VAN' || key === 'TAXI_CONV';

export const isTaxiTrip = (trip: TripForDriverOutput) => isTaxiPanel(trip.panelVars.key);

export const shortenFormattedAddress = (formattedAddress?: string) => (formattedAddress ?? '').replace(', France', '');
